import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { WordpressContentApiService } from '@app/shared/services/wordpress-content-api.service';
import { takeUntil } from 'rxjs/operators';
import { LanguageService } from '@app/shared/services/language.service';
import { Subject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-wp-page-content',
  templateUrl: './wp-page-content.component.html',
  styleUrls: ['./wp-page-content.component.scss'],
  standalone: false,
})
export class WpPageContentComponent implements OnInit, OnDestroy {
  @Input() page!: string;
  @Input() showHeadline = true;

  headline: string = '';
  content: string = '';

  private unsubscribe$ = new Subject<void>();

  constructor(
    protected wordpressService: WordpressContentApiService,
    private languageService: LanguageService,
    private translateService: TranslateService,
  ) {}

  ngOnInit() {
    this.languageService.currentLanguage$.pipe(takeUntil(this.unsubscribe$)).subscribe((lang: string) => {
      this.fetchContent();
    });
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  fetchContent() {
    this.wordpressService
      .getPageContent(this.page)
      .then((data) => {
        if (!data) {
          return;
        }

        this.headline = data.post_title;
        this.content = data.post_content;
      })
      .catch((error) => {
        this.headline = this.translateService.instant('error.unable-connect');
        this.content = this.translateService.instant('error.unknown');
      });
  }
}
